import React from 'react'
import SavedJob from '../../components/savedjob/SavedJob'

const SavedJobs = () => {
    return (
        <>
            <SavedJob />
        </>
    )
}

export default SavedJobs
